import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchVerifyModes,
  fetchVerifyModesSuccess,
  fetchVerifyModesFailure,
  fetchVerifyModeById,
  fetchVerifyModeByIdSuccess,
  fetchVerifyModeByIdFailure,
  addVerifyMode,
  addVerifyModeSuccess,
  addVerifyModeFailure,
  updateVerifyMode,
  updateVerifyModeSuccess,
  updateVerifyModeFailure,
  deleteVerifyMode,
  deleteVerifyModeSuccess,
  deleteVerifyModeFailure,
  bulkDeleteVerifyModes,
  bulkDeleteVerifyModesSuccess,
  bulkDeleteVerifyModesFailure,
} from './slice';
import * as deviceConfigService from '../../../services/deviceConfigService';

function* fetchVerifyModesSaga(action) {
  try {
    const { page, pageSize, sortColumn, sortDirection, filterName } = action.payload || {};

    const params = {};
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    if (sortColumn) {
      const pascalSort = String(sortColumn).replace(/^[a-z]/, (m) => m.toUpperCase());
      params.sortColumn = pascalSort;
      params.sortDirection = sortDirection || 'asc';
    }
    if (filterName) {
      params.search = filterName;
      params.searchTerm = filterName;
    }

    const response = yield call(deviceConfigService.getAllVerifyModes, params);
    yield put(fetchVerifyModesSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(fetchVerifyModesFailure(errorMessage));
  }
}

function* fetchVerifyModeByIdSaga(action) {
  try {
    const response = yield call(deviceConfigService.getVerifyModeById, action.payload);
    yield put(fetchVerifyModeByIdSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(fetchVerifyModeByIdFailure(errorMessage));
  }
}

function* addVerifyModeSaga(action) {
  try {
    const response = yield call(deviceConfigService.createVerifyMode, action.payload);
    yield put(addVerifyModeSuccess({
      data: response,
      message: response.message
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(addVerifyModeFailure(errorMessage));
  }
}

function* updateVerifyModeSaga(action) {
  try {
    const { id, ...data } = action.payload;
    const response = yield call(deviceConfigService.updateVerifyMode, id, data);
    yield put(updateVerifyModeSuccess({
      data: response,
      message: response.message
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(updateVerifyModeFailure(errorMessage));
  }
}

function* deleteVerifyModeSaga(action) {
  try {
    const response = yield call(deviceConfigService.deleteVerifyMode, action.payload);
    yield put(deleteVerifyModeSuccess({
      message: response?.message
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(deleteVerifyModeFailure(errorMessage));
  }
}

function* bulkDeleteVerifyModesSaga(action) {
  try {
    const response = yield call(deviceConfigService.bulkDeleteVerifyModes, action.payload);
    yield put(bulkDeleteVerifyModesSuccess({
      message: response?.message
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(bulkDeleteVerifyModesFailure(errorMessage));
  }
}

// Watcher saga
export function* watchVerifyModesActions() {
  yield takeLatest(fetchVerifyModes.type, fetchVerifyModesSaga);
  yield takeLatest(fetchVerifyModeById.type, fetchVerifyModeByIdSaga);
  yield takeLatest(addVerifyMode.type, addVerifyModeSaga);
  yield takeLatest(updateVerifyMode.type, updateVerifyModeSaga);
  yield takeLatest(deleteVerifyMode.type, deleteVerifyModeSaga);
  yield takeLatest(bulkDeleteVerifyModes.type, bulkDeleteVerifyModesSaga);
}

export default watchVerifyModesActions;
